import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface UserChannel {
  channel_id: string;
  organization_name: string;
  is_primary: boolean;
  channels: {
    id: string;
    name: string;
    slug: string;
  };
}

export const useUserChannels = (userId?: string) => {
  return useQuery({
    queryKey: ['user-channels', userId],
    queryFn: async () => {
      if (!userId) return [];
      
      const { data, error } = await supabase
        .from('user_organizations')
        .select(`
          channel_id,
          organization_name,
          is_primary,
          channels (
            id,
            name,
            slug
          )
        `)
        .eq('user_id', userId);
      
      if (error) throw error;
      return data as UserChannel[];
    },
    enabled: !!userId,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
};
